import { useState } from 'react';
import './ProfilePublishModal.css';

export default function ProfilePublishModal({ isOpen, nextVersionNumber, onPublish, onClose, isPublishing }) {
  const [tag, setTag] = useState('');
  const [summary, setSummary] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);

  async function handlePublish() {
    try {
      await onPublish({
        version_tag: tag || `v${nextVersionNumber}`,
        change_summary: summary
      });
      setShowSuccess(true);
      setTimeout(() => {
        setShowSuccess(false);
        setTag('');
        setSummary('');
        onClose();
      }, 1500);
    } catch (err) {
      alert('Failed to publish: ' + err.message);
    }
  }

  if (!isOpen) return null;

  return (
    <div className="profile-publish-overlay" onClick={onClose}>
      <div className="profile-publish-modal" onClick={e => e.stopPropagation()}>
        {!showSuccess ? (
          <>
            <div className="profile-publish-modal__icon">&#128640;</div>
            <div className="profile-publish-modal__title">Publish Profile Templates?</div>
            <div className="profile-publish-modal__subtitle">
              Create an immutable snapshot of all 6 profile template configurations
            </div>

            <div className="profile-publish-modal__version-label">Publishing as Version</div>
            <div className="profile-publish-modal__version-num">v{nextVersionNumber}</div>

            <div className="profile-publish-modal__field">
              <label className="profile-publish-modal__label">Version Tag (optional)</label>
              <input
                type="text"
                className="profile-publish-modal__input"
                value={tag}
                onChange={e => setTag(e.target.value)}
                placeholder={`v${nextVersionNumber} - e.g., Q1 2025 Profile Config`}
              />
            </div>

            <div className="profile-publish-modal__field">
              <label className="profile-publish-modal__label">Change Summary (optional)</label>
              <textarea
                className="profile-publish-modal__textarea"
                value={summary}
                onChange={e => setSummary(e.target.value)}
                placeholder="Describe what changed in this version..."
              />
            </div>

            <div className="profile-publish-modal__buttons">
              <button className="btn btn--outline" onClick={onClose} disabled={isPublishing}>Cancel</button>
              <button
                className={`btn ${isPublishing ? 'btn--disabled' : 'btn--primary'}`}
                onClick={handlePublish}
                disabled={isPublishing}
              >
                {isPublishing ? 'Publishing...' : 'Publish & Lock'}
              </button>
            </div>
          </>
        ) : (
          <div className="profile-publish-modal__success">
            <div className="profile-publish-modal__success-icon">&#10003;</div>
            <div className="profile-publish-modal__title">Version Published!</div>
          </div>
        )}
      </div>
    </div>
  );
}
